import { PayloadAction, createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { HttpError, HttpService } from 'src/toolkit';

import { TAccountClient, TAccountClientBodyRequest, TAccountClientResponse, adaptAccountClientFromResponse, adaptAccountClientToRequest } from '../../types';
import { TSliceInitialState, useAppSelector } from '../../hooks';
import { BACKEND_ACCOUNT_CLIENT } from '../../backend-paths';


export const accountClientCreateApi = createAsyncThunk(
	`POST/${BACKEND_ACCOUNT_CLIENT}`,
	(payload: TAccountClientBodyRequest, thunkApi) => {
		const dataRequest = adaptAccountClientToRequest(payload);

		return HttpService.post<TAccountClientResponse>(BACKEND_ACCOUNT_CLIENT, dataRequest).then(result => {
			return adaptAccountClientFromResponse(result.data);
		}).catch((error: HttpError) => {
			return thunkApi.rejectWithValue({ ...error });
		});
	},
);

const initialState: TSliceInitialState<TAccountClient> = {
	item: undefined,
	isLoading: false,
	error: undefined,
};

export const accountClientCreateSlice = createSlice({
	name: 'accountClientCreateSlice',
	initialState,
	reducers: {
		clearAccountClientCreate(state) {
			return { ...initialState };
		},
	},

	extraReducers: {
		[accountClientCreateApi.pending.type]: (state) => {
			state.error = undefined;
			state.isLoading = true;
		},

		[accountClientCreateApi.fulfilled.type]: (state, action: PayloadAction<TAccountClient>) => {
			state.isLoading = false;
			state.item = action.payload;
		},

		[accountClientCreateApi.rejected.type]: (state, action: PayloadAction<HttpError>) => {
			state.error = action.payload;
			state.isLoading = false;
		},
	},
});

export const useAccountClientCreateSelector = () => useAppSelector(state => state[accountClientCreateSlice.name]);

export const { clearAccountClientCreate } = accountClientCreateSlice.actions;
